// SatelliteBackdrop.js — the KML/satellite counterpart to the orthophoto raster.
// Composes the tile imagery with the KML reference geometry so ImageEditor sees
// a single `backdrop` node and needs to know nothing about either.
import React from 'react';
import TileBackdrop, { ESRI_ATTRIBUTION } from './TileBackdrop';
import KmlOverlay from './KmlOverlay';
import MarkerLayer from './MarkerLayer';

export default function SatelliteBackdrop({ frame, features, markers = [], currentScale = 1, position = null }) {
  return (
    <>
      <TileBackdrop frame={frame} currentScale={currentScale} position={position} />
      <KmlOverlay features={features} frame={frame} currentScale={currentScale} position={position} />
      <MarkerLayer markers={markers} frame={frame} currentScale={currentScale} position={position} />
    </>
  );
}

export { ESRI_ATTRIBUTION };
